/* R57: no carrinho lateral, "+" / "-" de uma linha do AtlasFit troca de pacote (1 -> 2 -> 4 pecas = Buy 1 Get 1 FREE / Buy 2 Get 2 FREE), sem mexer em preco: so troca a variante Bundle que ja existe. */
(function () {
  var FIT = 'adjustable-posture-corrector-for-men-women', busy = false;
  async function swap(d, next, wrap) {
    if (busy) return; busy = true;
    var btns = wrap.querySelectorAll('button'); btns.forEach(function (b) { b.disabled = true; });
    try {
      var pj = await (await fetch('/products/' + FIT + '.js')).json();
      var want = next + (next > 1 ? ' Braces' : ' Brace');
      var v = pj.variants.filter(function (x) { return x.option1 === d.c && x.option2 === d.s && x.option3 === want && x.available; })[0];
      var cart = await (await fetch('/cart.js')).json();
      var line = cart.items.filter(function (i) { return i.key === d.key; })[0];
      if (!v || !line) throw new Error('no variant');
      var props = {}, base = d.c + ' / ' + d.s;
      Object.keys(line.properties || {}).forEach(function (k) { if (!/^Item \d+$/.test(k)) props[k] = line.properties[k]; });
      for (var k = 1; k <= next; k++) props['Item ' + k] = (line.properties && line.properties['Item ' + k]) || base;
      var ok = await window.abAdd([{ id: v.id, quantity: 1, properties: props }], null);
      if (ok) {
        var rm = null;
        for (var t = 0; t < 3 && !(rm && rm.ok); t++) {
          var up = {}; up[d.key] = 0; rm = await fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ updates: up }) });
          if (!rm.ok) await new Promise(function (r) { setTimeout(r, 600); });
        }
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      }
    } catch (e) {
      btns.forEach(function (b) { b.disabled = false; });
    }
    busy = false;
  }
  document.addEventListener('click', function (ev) {
    var step = ev.target.closest('[data-ab-qty]');
    if (!step || !document.documentElement.classList.contains('ab-r57')) return;
    var q = step.closest('.ab57-q');
    if (!q || !q.getAttribute('data-ab-bundle')) return;
    var p = parseInt(q.getAttribute('data-ab-bundle'), 10), dir = parseInt(step.getAttribute('data-ab-qty'), 10);
    var next = dir > 0 ? (p < 2 ? 2 : (p < 4 ? 4 : 0)) : (p > 2 ? 2 : (p > 1 ? 1 : 0));
    if (!next) { if (dir > 0) { ev.preventDefault(); ev.stopImmediatePropagation(); } return; }
    ev.preventDefault(); ev.stopImmediatePropagation();
    swap({ c: q.getAttribute('data-c'), s: q.getAttribute('data-s'), key: q.getAttribute('data-key') }, next, q);
  }, true);
})();
/* AtlasBack: adicionar ao carrinho e quantidade na linha, em cima dos eventos nativos do tema Impact. */
(function () {
  var ERR_NET = 'Could not add to your order. Check your connection and try again.';
  var busy = false;

  function root() { return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'; }

  /* o tema diz quais secoes precisa de volta (carrinho lateral etc.); nunca chutar o id */
  function bundledSections(extra) {
    var list = (extra || []).slice();
    document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', { bubbles: true, detail: { sections: list } }));
    return list;
  }

  function showError(btn, msg) {
    if (!btn) return;
    var el = btn.nextElementSibling;
    if (!el || !el.classList.contains('ab-err')) {
      el = document.createElement('p');
      el.className = 'ab-err';
      el.setAttribute('role', 'alert');
      btn.insertAdjacentElement('afterend', el);
    }
    el.textContent = msg || '';
    el.hidden = !msg;
  }

  function isCartPage() {
    return window.themeVariables && themeVariables.settings && themeVariables.settings.pageType === 'cart';
  }

  /* Um clique = uma adicao. Abre o carrinho lateral ja com o item; se falhar, mostra a mensagem perto do botao. */
  window.abAdd = async function (items, btn) {
    if (busy) return false;
    busy = true;
    var btns = Array.prototype.slice.call(document.querySelectorAll('[data-ab-atc]'));
    if (btn && btns.indexOf(btn) < 0) btns.push(btn);
    var wasDisabled = btns.map(function (b) { return b.disabled; });
    btns.forEach(function (b) { b.disabled = true; b.setAttribute('aria-busy', 'true'); });
    var label = btn ? btn.textContent : '';
    if (btn) { btn.textContent = 'Adding…'; showError(btn, ''); }
    var ok = false;
    try {
      var secs = bundledSections(['variant-added']);
      var res = await fetch(root() + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ items: items, sections: secs.join(','), sections_url: root() + 'variants/' + items[0].id })
      });
      var json = await res.json();
      if (!res.ok) { var err = new Error(json.description || json.message || 'This item could not be added.'); err.fromShop = true; throw err; }
      if (isCartPage()) { window.location.href = root() + 'cart'; return true; }
      var cart = await (await fetch(root() + 'cart.js')).json();
      cart.sections = json.sections || {};
      var complete = secs.every(function (s) { return s === 'variant-added' || cart.sections[s]; });
      var detailItems = json.items || [json];
      if (complete) {
        document.dispatchEvent(new CustomEvent('variant:add', { bubbles: true, detail: { items: detailItems, cart: cart } }));
        document.documentElement.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { baseEvent: 'variant:add', cart: cart } }));
      } else {
        /* sem o HTML da secao na resposta: recarrega o carrinho lateral do servidor antes de abrir */
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        document.dispatchEvent(new CustomEvent('variant:add', { bubbles: true, detail: { items: detailItems, cart: cart } }));
      }
      ok = true;
    } catch (e) {
      showError(btn, e && e.fromShop ? e.message : ERR_NET);
    } finally {
      btns.forEach(function (b, i) { b.disabled = wasDisabled[i]; b.removeAttribute('aria-busy'); });
      if (btn) btn.textContent = label;
      busy = false;
    }
    return ok;
  };

  /* Quantidade da linha (carrinho lateral e /cart), sem recarregar a pagina. qty 0 remove. */
  window.abCartQty = async function (lineKey, qty, origin) {
    var line = origin && origin.closest('line-item, tr');
    if (line) line.classList.add('ab-busy');
    var marker = document.querySelector('[data-ab-cart-section]');
    var mainId = marker ? marker.getAttribute('data-ab-cart-section') : null;
    var secs = bundledSections(mainId ? [mainId] : []);
    try {
      var res = await fetch(root() + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: lineKey, quantity: qty, sections: secs })
      });
      var cart = await res.json();
      if (!res.ok) throw new Error(cart.description || 'cart error');
      if (mainId && cart.sections && cart.sections[mainId]) {
        var doc = new DOMParser().parseFromString(cart.sections[mainId], 'text/html');
        var fresh = doc.getElementById('shopify-section-' + mainId);
        var current = document.getElementById('shopify-section-' + mainId);
        if (fresh && current) current.innerHTML = fresh.innerHTML;
      }
      document.documentElement.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { baseEvent: 'variant:add', cart: cart } }));
    } catch (e) {
      if (line) line.classList.remove('ab-busy');
      document.querySelectorAll('.ab-qty button').forEach(function (b) { b.disabled = false; });
      showCartErr(function () { window.abCartQty(lineKey, qty, origin); });
    }
  };

  /* Erro de rede no carrinho: mensagem curta com "Try again" (sem recarregar a pagina). */
  function showCartErr(retry) {
    var host = document.querySelector('.cart-drawer__line-items') || document.querySelector('.order-summary');
    if (!host) { window.location.reload(); return; }
    var old = document.querySelector('.abx-err'); if (old) old.remove();
    var el = document.createElement('div');
    el.className = 'abx-err'; el.setAttribute('role', 'alert');
    el.innerHTML = '<span>We couldn’t update your cart. Check your connection.</span><button type="button">Try again</button>';
    el.querySelector('button').addEventListener('click', function () { el.remove(); retry(); });
    host.parentNode.insertBefore(el, host);
  }

  document.addEventListener('click', function (ev) {
    var step = ev.target.closest('[data-ab-qty]');
    if (step) {
      ev.preventDefault();
      var wrap = step.closest('.ab-qty');
      var input = wrap && wrap.querySelector('input');
      if (!input || step.disabled) return;
      var next = Math.max(0, (parseInt(input.value, 10) || 1) + parseInt(step.getAttribute('data-ab-qty'), 10));
      wrap.querySelectorAll('button').forEach(function (b) { b.disabled = true; });
      window.abCartQty(input.getAttribute('data-line-key'), next, step);
      return;
    }
    var rm = ev.target.closest('[data-ab-remove]');
    if (rm) {
      ev.preventDefault();
      ev.stopPropagation();
      window.abCartQty(rm.getAttribute('data-ab-remove'), 0, rm);
    }
  }, true);
})();
